import * as React from 'react';

import type { Logger } from '@feature-hub/core';

import { useSafeContext } from './use-safe-context';

type Logging = {
	readonly logger: Logger;
};

const LoggingContext = React.createContext<Logging | undefined>(undefined);

export function useLogger(): Logger {
	return useSafeContext(LoggingContext, 'LoggingContext').logger;
}

type LoggingProviderProps = React.PropsWithChildren<{ logger: Logger }>;

export function LoggingProvider({ logger, children }: LoggingProviderProps): React.ReactElement {
	return <LoggingContext.Provider value={{ logger }}>{children}</LoggingContext.Provider>;
}
